import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaHome, FaBed, FaSignOutAlt, FaCalendarAlt, FaTools, FaCog } from 'react-icons/fa';
import { auth, db } from '../../../firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import './index.css';

/**
 * AdminSidebar component for admin navigation
 * Displays sidebar menu with admin options and user profile
 * @returns {JSX.Element|null} Admin sidebar or null if not authenticated
 */
const AdminSidebar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState('LU'); 

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const role = userData.role;
            if (role === 'admin') {
              setUser(currentUser);
              setUserName(userData.name ? userData.name.charAt(0).toUpperCase() : 'LU');
            } else {
              await signOut(auth);
              navigate('/');
            }
          } else {
            await signOut(auth);
            navigate('/');
          }
        } catch (error) {
          await signOut(auth);
          navigate('/');
        }
      } else {
        setUser(null);
        navigate('/');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch {
      // Handle logout error silently
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="avatar">{userName}</div>
        <h4>Admin</h4>
      </div>
      <ul className="sidebar-menu">
        <li>
          <NavLink to="/admin-dashboard" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaCog /> Add Account
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-dashboard/property" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaBed /> Add Property
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-dashboard/availability" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaCalendarAlt /> Add Availability
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-dashboard/services" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaTools /> Update Services
          </NavLink>
        </li>
      </ul>
      <NavLink to="/" className="mb-3 mt-3" style={{ textDecoration: 'none', color: 'inherit' }}>
        <FaHome /> Back to Home
      </NavLink>
      <div className="logout" onClick={handleLogout}>
        <FaSignOutAlt /> Log out
      </div>
    </div>
  );
};

export default AdminSidebar;